var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _circle, _circle2, _circle3, _rect36, _path, _g, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _circle4, _circle5, _circle6, _path2, _ellipse, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _path20, _path21, _path22, _path23, _path24, _ellipse2, _path25, _path26, _rect78, _rect79, _g2, _rect80, _rect81, _rect82, _rect83, _rect84, _path27, _circle7, _circle8, _circle9, _circle10, _rect85, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 325,
    viewBox: "0 0 480 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 114.29,
    y: 112.985,
    width: 46.5473,
    height: 78.9641,
    rx: 2.4936,
    fill: "#F8F8F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 37.4699,
    height: 1.90929,
    transform: "translate(118.446 124.206)",
    fill: "#F8F8F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 118.446,
    y: 124.206,
    width: 7.15985,
    height: 1.90929,
    fill: "#FFD200"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 128.231,
    y: 124.206,
    width: 14.5584,
    height: 1.90929,
    fill: "#38C0EB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 145.415,
    y: 124.206,
    width: 10.5011,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 24.3435,
    height: 1.90929,
    transform: "translate(122.981 128.741)",
    fill: "#F8F8F8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 122.981,
    y: 128.741,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 133.004,
    y: 128.741,
    width: 14.3197,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 24.3435,
    height: 1.90929,
    transform: "translate(122.981 132.798)",
    fill: "#F8F8F8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 122.981,
    y: 132.798,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 133.004,
    y: 132.798,
    width: 14.3197,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 25.7755,
    height: 1.90929,
    transform: "translate(118.446 137.333)",
    fill: "#F8F8F8"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 118.446,
    y: 137.332,
    width: 7.15985,
    height: 1.90929,
    fill: "#FFD200"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 128.515,
    y: 137.333,
    width: 27.014,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9569,
    height: 1.90929,
    transform: "translate(120.356 141.867)",
    fill: "#F8F8F8"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 120.356,
    y: 141.867,
    width: 7.15985,
    height: 1.90929,
    fill: "#38C0EB"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 130.141,
    y: 141.867,
    width: 12.1718,
    height: 1.90929,
    fill: "#FFD200"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 129.424,
    y: 146.402,
    width: 8.1145,
    height: 1.90929,
    fill: "#F8F8F8"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 37.4699,
    height: 1.90929,
    transform: "translate(118.446 152.467)",
    fill: "#F8F8F8"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 118.446,
    y: 152.467,
    width: 7.15985,
    height: 1.90929,
    fill: "#FFD200"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 128.231,
    y: 152.467,
    width: 14.5584,
    height: 1.90929,
    fill: "#38C0EB"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 145.415,
    y: 152.467,
    width: 10.5011,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 24.3435,
    height: 1.90929,
    transform: "translate(122.981 157.002)",
    fill: "#F8F8F8"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 122.981,
    y: 157.002,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 133.004,
    y: 157.002,
    width: 14.3197,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 24.3435,
    height: 1.90929,
    transform: "translate(122.981 161.059)",
    fill: "#F8F8F8"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 122.981,
    y: 161.059,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 133.004,
    y: 161.059,
    width: 14.3197,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 25.7755,
    height: 1.90929,
    transform: "translate(118.446 165.593)",
    fill: "#F8F8F8"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 118.446,
    y: 165.594,
    width: 7.15985,
    height: 1.90929,
    fill: "#FFD200"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 128.515,
    y: 165.593,
    width: 27.014,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9569,
    height: 1.90929,
    transform: "translate(120.356 170.128)",
    fill: "#F8F8F8"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 120.356,
    y: 170.128,
    width: 7.15985,
    height: 1.90929,
    fill: "#38C0EB"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 130.141,
    y: 170.128,
    width: 12.1718,
    height: 1.90929,
    fill: "#FFD200"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 129.424,
    y: 174.663,
    width: 8.1145,
    height: 1.90929,
    fill: "#F8F8F8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 119.349,
    cy: 118.044,
    r: 0.902857,
    fill: "#38C0EB"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 121.986,
    cy: 118.044,
    r: 0.902857,
    fill: "#6638EB"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.623,
    cy: 118.044,
    r: 0.902857,
    fill: "#FFD200"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 165.409,
    y: 112.985,
    width: 107.641,
    height: 78.9641,
    rx: 2.4936,
    fill: "#F8F8F8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_661",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 112,
    width: 109,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.409 117.972C165.409 115.621 165.409 114.446 166.139 113.716C166.87 112.985 168.045 112.985 170.396 112.985H268.062C270.413 112.985 271.589 112.985 272.319 113.716C273.049 114.446 273.049 115.621 273.049 117.972V186.962C273.049 189.313 273.049 190.489 272.319 191.219C271.589 191.949 270.413 191.949 268.062 191.949H170.396C168.045 191.949 166.87 191.949 166.139 191.219C165.409 190.489 165.409 189.313 165.409 186.962V117.972Z",
    fill: "#D55151"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_661)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94.473,
    height: 1.90929,
    transform: "translate(170.396 123.375)",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.396,
    y: 123.375,
    width: 7.15985,
    height: 1.90929,
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.049,
    y: 123.375,
    width: 14.5584,
    height: 1.90929,
    fill: "#38C0EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.101,
    y: 123.375,
    width: 14.5584,
    height: 1.90929,
    fill: "#38C0EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.153,
    y: 123.375,
    width: 14.5584,
    height: 1.90929,
    fill: "#38C0EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.205,
    y: 123.375,
    width: 33.6637,
    height: 1.90929,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.3477,
    height: 1.90929,
    transform: "translate(176.794 127.91)",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.794,
    y: 127.909,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.863,
    y: 127.909,
    width: 51.5345,
    height: 1.90929,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.307,
    y: 127.909,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.3477,
    height: 1.90929,
    transform: "translate(176.794 131.967)",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.794,
    y: 131.967,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.863,
    y: 131.967,
    width: 51.5345,
    height: 1.90929,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.307,
    y: 131.967,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52.1892,
    height: 1.6624,
    transform: "translate(170.396 136.674)",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.395,
    y: 136.674,
    width: 7.15985,
    height: 1.90929,
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.465,
    y: 136.674,
    width: 24.936,
    height: 1.90929,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.31,
    y: 136.674,
    width: 7.06521,
    height: 2.078,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.284,
    y: 136.674,
    width: 7.06521,
    height: 2.078,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.258,
    y: 136.674,
    width: 7.06521,
    height: 2.078,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.233,
    y: 136.674,
    width: 7.06521,
    height: 2.078,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.9803,
    height: 1.90929,
    transform: "translate(173.09 141.036)",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.09,
    y: 141.036,
    width: 7.15985,
    height: 1.90929,
    fill: "#38C0EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.875,
    y: 141.036,
    width: 53.6125,
    height: 1.90929,
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 94.473,
    height: 1.90929,
    transform: "translate(170.396 149.974)",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.396,
    y: 149.974,
    width: 7.15985,
    height: 1.90929,
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.049,
    y: 149.974,
    width: 14.5584,
    height: 1.90929,
    fill: "#38C0EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.101,
    y: 149.974,
    width: 14.5584,
    height: 1.90929,
    fill: "#38C0EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.153,
    y: 149.974,
    width: 14.5584,
    height: 1.90929,
    fill: "#38C0EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.205,
    y: 149.974,
    width: 33.6637,
    height: 1.90929,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.3477,
    height: 1.90929,
    transform: "translate(176.794 154.508)",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.794,
    y: 154.508,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.863,
    y: 154.508,
    width: 51.5345,
    height: 1.90929,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.307,
    y: 154.508,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 34.3477,
    height: 1.90929,
    transform: "translate(176.794 158.565)",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.794,
    y: 158.565,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.863,
    y: 158.565,
    width: 51.5345,
    height: 1.90929,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.307,
    y: 158.565,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 52.1892,
    height: 1.6624,
    transform: "translate(170.396 163.273)",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.395,
    y: 163.273,
    width: 7.15985,
    height: 1.90929,
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.465,
    y: 163.273,
    width: 24.936,
    height: 1.90929,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.31,
    y: 163.273,
    width: 7.06521,
    height: 2.078,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.284,
    y: 163.273,
    width: 7.06521,
    height: 2.078,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.258,
    y: 163.273,
    width: 7.06521,
    height: 2.078,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.233,
    y: 163.273,
    width: 7.06521,
    height: 2.078,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.9803,
    height: 1.90929,
    transform: "translate(173.09 167.635)",
    fill: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.09,
    y: 167.635,
    width: 7.15985,
    height: 1.90929,
    fill: "#38C0EB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.875,
    y: 167.635,
    width: 53.6125,
    height: 1.90929,
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.883,
    cy: 118.044,
    r: 0.902857,
    fill: "#38C0EB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 173.52,
    cy: 118.044,
    r: 0.902857,
    fill: "#6638EB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.157,
    cy: 118.044,
    r: 0.902857,
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 107.641,
    height: 13.2992,
    transform: "translate(165.409 178.65)",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.853,
    cy: 184.884,
    r: 3.74041,
    fill: "#D9D9D9"
  }))), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 277.621,
    y: 112.985,
    width: 46.5473,
    height: 78.9641,
    rx: 2.4936,
    fill: "#F8F8F8"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    width: 37.4699,
    height: 1.90929,
    transform: "translate(281.777 124.206)",
    fill: "#F8F8F8"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 281.777,
    y: 124.206,
    width: 7.15985,
    height: 1.90929,
    fill: "#FFD200"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 291.562,
    y: 124.206,
    width: 14.5584,
    height: 1.90929,
    fill: "#38C0EB"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 308.746,
    y: 124.206,
    width: 10.5011,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    width: 24.3435,
    height: 1.90929,
    transform: "translate(286.312 128.741)",
    fill: "#F8F8F8"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 286.312,
    y: 128.741,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 296.336,
    y: 128.741,
    width: 14.3197,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 24.3435,
    height: 1.90929,
    transform: "translate(286.312 132.798)",
    fill: "#F8F8F8"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 286.312,
    y: 132.798,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 296.336,
    y: 132.798,
    width: 14.3197,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    width: 25.7755,
    height: 1.90929,
    transform: "translate(281.777 137.333)",
    fill: "#F8F8F8"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 281.778,
    y: 137.333,
    width: 7.15985,
    height: 1.90929,
    fill: "#FFD200"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 291.846,
    y: 137.333,
    width: 27.014,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9569,
    height: 1.90929,
    transform: "translate(283.687 141.867)",
    fill: "#F8F8F8"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 283.687,
    y: 141.867,
    width: 7.15985,
    height: 1.90929,
    fill: "#38C0EB"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 293.472,
    y: 141.867,
    width: 12.1718,
    height: 1.90929,
    fill: "#FFD200"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 292.756,
    y: 146.402,
    width: 8.1145,
    height: 1.90929,
    fill: "#F8F8F8"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 37.4699,
    height: 1.90929,
    transform: "translate(281.777 152.467)",
    fill: "#F8F8F8"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 281.777,
    y: 152.467,
    width: 7.15985,
    height: 1.90929,
    fill: "#FFD200"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 291.562,
    y: 152.467,
    width: 14.5584,
    height: 1.90929,
    fill: "#38C0EB"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 308.746,
    y: 152.467,
    width: 10.5011,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 24.3435,
    height: 1.90929,
    transform: "translate(286.312 157.002)",
    fill: "#F8F8F8"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 286.312,
    y: 157.002,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 296.336,
    y: 157.002,
    width: 14.3197,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    width: 24.3435,
    height: 1.90929,
    transform: "translate(286.312 161.059)",
    fill: "#F8F8F8"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 286.312,
    y: 161.059,
    width: 7.15985,
    height: 1.90929,
    fill: "#D9D9D9"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 296.336,
    y: 161.059,
    width: 14.3197,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 25.7755,
    height: 1.90929,
    transform: "translate(281.777 165.593)",
    fill: "#F8F8F8"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 281.778,
    y: 165.594,
    width: 7.15985,
    height: 1.90929,
    fill: "#FFD200"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 291.846,
    y: 165.594,
    width: 27.014,
    height: 1.90929,
    fill: "#6638EB"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    width: 21.9569,
    height: 1.90929,
    transform: "translate(283.687 170.128)",
    fill: "#F8F8F8"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 283.687,
    y: 170.128,
    width: 7.15985,
    height: 1.90929,
    fill: "#38C0EB"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 293.472,
    y: 170.128,
    width: 12.1718,
    height: 1.90929,
    fill: "#FFD200"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 292.756,
    y: 174.663,
    width: 8.1145,
    height: 1.90929,
    fill: "#F8F8F8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.68,
    cy: 118.044,
    r: 0.902857,
    fill: "#38C0EB"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 285.317,
    cy: 118.044,
    r: 0.902857,
    fill: "#6638EB"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.954,
    cy: 118.044,
    r: 0.902857,
    fill: "#FFD200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M210.294 191.949H228.58L233.567 212.314H205.514L210.294 191.949Z",
    fill: "#D9D9D9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 219.229,
    ry: 29.2998,
    transform: "matrix(-1 0 0 1 219.229 294.811)",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M410.897 287.264C398.016 274.571 417.728 241.465 417.728 241.465",
    stroke: "#D1D5DA",
    strokeWidth: 0.794031,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M417.626 234.825C418.874 231.567 423.624 228.206 423.624 228.206C423.624 228.206 424.711 234.276 422.916 237.397C421.461 239.929 417.161 242.172 417.161 242.172C417.161 242.172 416.597 237.509 417.626 234.825Z",
    fill: "#959DA5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M408.21 243.931C406.608 240.832 407.256 235.049 407.256 235.049C407.256 235.049 412.513 238.275 413.65 241.691C414.573 244.461 413.388 249.164 413.388 249.164C413.388 249.164 409.531 246.485 408.21 243.931Z",
    fill: "#EDF0F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M403.015 257.168C401.413 254.07 402.061 248.287 402.061 248.287C402.061 248.287 407.317 251.513 408.455 254.928C409.378 257.699 408.193 262.402 408.193 262.402C408.193 262.402 404.336 259.722 403.015 257.168Z",
    fill: "#EDF0F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M400.284 269.857C398.286 266.997 398.164 261.18 398.164 261.18C398.164 261.18 403.801 263.682 405.38 266.917C406.662 269.541 406.109 274.359 406.109 274.359C406.109 274.359 401.931 272.214 400.284 269.857Z",
    fill: "#EDF0F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M420.381 253.135C417.355 254.871 411.549 254.475 411.549 254.475C411.549 254.475 414.543 249.083 417.906 247.798C420.634 246.755 425.384 247.734 425.384 247.734C425.384 247.734 422.875 251.705 420.381 253.135Z",
    fill: "#D1D5DA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M416.248 265.915C413.222 267.65 407.416 267.254 407.416 267.254C407.416 267.254 410.41 261.863 413.773 260.577C416.501 259.535 421.251 260.514 421.251 260.514C421.251 260.514 418.742 264.484 416.248 265.915Z",
    fill: "#D1D5DA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M415.76 278.383C412.734 280.118 406.929 279.722 406.929 279.722C406.929 279.722 409.923 274.331 413.285 273.045C416.013 272.003 420.763 272.982 420.763 272.982C420.763 272.982 418.254 276.952 415.76 278.383Z",
    fill: "#D1D5DA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M402.323 284.242C412.635 269.386 387.142 240.495 387.142 240.495",
    stroke: "#D1D5DA",
    strokeWidth: 0.794031,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M386.016 233.95C384.187 230.98 378.897 228.554 378.897 228.554C378.897 228.554 378.952 234.721 381.292 237.457C383.19 239.676 387.831 241.084 387.831 241.084C387.831 241.084 387.523 236.398 386.016 233.95Z",
    fill: "#959DA5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M396.953 241.159C397.954 237.817 396.248 232.254 396.248 232.254C396.248 232.254 391.679 236.396 391.192 239.963C390.798 242.856 392.832 247.259 392.832 247.259C392.832 247.259 396.127 243.913 396.953 241.159Z",
    fill: "#EDF0F2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M404.505 253.208C405.507 249.866 403.8 244.303 403.8 244.303C403.8 244.303 399.231 248.445 398.745 252.012C398.35 254.906 400.384 259.308 400.384 259.308C400.384 259.308 403.679 255.962 404.505 253.208Z",
    fill: "#EDF0F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M386.694 252.454C389.988 253.601 395.621 252.138 395.621 252.138C395.621 252.138 391.682 247.393 388.139 246.751C385.266 246.231 380.779 248.072 380.779 248.072C380.779 248.072 383.978 251.509 386.694 252.454Z",
    fill: "#D1D5DA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M393.117 264.25C396.412 265.396 402.044 263.933 402.044 263.933C402.044 263.933 398.105 259.188 394.563 258.547C391.689 258.026 387.202 259.867 387.202 259.867C387.202 259.867 390.402 263.305 393.117 264.25Z",
    fill: "#D1D5DA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M395.901 276.413C399.196 277.559 404.828 276.096 404.828 276.096C404.828 276.096 400.89 271.351 397.347 270.71C394.473 270.189 389.986 272.03 389.986 272.03C389.986 272.03 393.186 275.468 395.901 276.413Z",
    fill: "#D1D5DA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M397.737 260.822C397.737 260.822 398.647 243.85 395.243 233.824C392.959 227.097 386.773 217.724 386.773 217.724",
    stroke: "#D1D5DA",
    strokeWidth: 0.226866
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M405.552 289.616C397.933 289.616 395.797 281.448 395.797 281.448H415.308C415.308 281.448 413.172 289.616 405.552 289.616Z",
    fill: "#D9D9D9"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 83.9514,
    y: 207.327,
    width: 270.972,
    height: 85.6137,
    fill: "#D1D5DA"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 61.9245,
    y: 197.768,
    width: 315.025,
    height: 9.55882,
    fill: "#F8F8F8"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 70.2366,
    y: 292.94,
    width: 95.1726,
    height: 13.7148,
    transform: "rotate(-90 70.2366 292.94)",
    fill: "#F8F8F8"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 354.923,
    y: 292.94,
    width: 95.1726,
    height: 13.7148,
    transform: "rotate(-90 354.923 292.94)",
    fill: "#F8F8F8"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 296.739,
    y: 292.94,
    width: 95.1726,
    height: 7.89641,
    transform: "rotate(-90 296.739 292.94)",
    fill: "#F8F8F8"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 296.739,
    y: 279.225,
    width: 71.8989,
    height: 13.7148,
    fill: "#F8F8F8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M144.744 168.979C139.418 159.717 158.058 136.933 163.606 133.418C169.154 129.903 168.266 131.764 168.266 131.764L163.606 187.793C159.538 185.381 150.07 178.242 144.744 168.979Z",
    fill: "#7546FB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M256.633 136.051C248.124 127.905 216.528 125.245 216.528 125.245C218.398 146.302 218.768 173.335 240.425 190.287C259.24 205.014 278.66 198.46 296.531 197.56V191.742C296.531 191.742 273.868 192.437 262.244 180.52C249.053 166.998 270.279 149.114 256.633 136.051Z",
    fill: "#7546FB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M221.553 219.593C221.553 219.593 273.08 150.426 242.956 132.732C229.961 125.099 219.321 125.077 203.992 125.044L203.682 125.044C188.186 125.011 178.165 124.851 164.823 132.732C135.211 150.226 179.369 219.593 179.369 219.593H221.553Z",
    fill: "#6638EB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M210.229 126.265L209.961 114.705C209.961 114.705 207.528 114.017 206.106 113.27C203.792 112.055 201.056 108.892 201.056 108.892L199.139 126.512L210.229 126.265Z",
    fill: "#FFDAB8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M203.604 113.887C202.073 112.3 201.056 108.892 201.056 108.892L210.062 114.795L209.983 115.954L209.903 117.113C209.903 117.113 205.523 115.876 203.604 113.887Z",
    fill: "#EDC199"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 211.237,
    cy: 93.4031,
    rx: 15.1694,
    ry: 22.3328,
    transform: "rotate(11.7233 211.237 93.4031)",
    fill: "#FFDAB8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M197.587 103.78C218.91 104.406 207.562 91.1574 214.322 91.1574C217.032 91.1574 217.367 97.3916 217.367 97.3916L222.731 89.4176L228.58 88.257C228.58 88.257 227.952 75.0791 224.424 72.672C219.704 69.4518 213.514 69.0803 208.216 71.2174C191.799 73.7111 194.293 87.8413 194.293 87.8413C194.293 87.8413 192.631 103.634 197.587 103.78Z",
    fill: "#07122A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M177.877 223.535L179.332 219.379H221.931C221.931 219.379 240.747 231.042 242.503 243.484C245.228 262.787 206.346 288.576 206.346 288.576V282.966C206.346 282.966 220.737 263.988 218.606 250.757C217.342 242.91 205.723 237.458 205.723 237.458C205.723 237.458 189.129 235.391 183.903 245.354C177.212 258.114 198.657 280.888 198.657 280.888L198.657 285.252C198.657 285.252 162.618 266.77 163.331 249.302C163.803 237.756 177.877 223.535 177.877 223.535Z",
    fill: "#07122A"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 166.24,
    y: 235.172,
    width: 72.3145,
    height: 19.5332,
    rx: 9.76662,
    fill: "#FFD200"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_661",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 166,
    y: 235,
    width: 73,
    height: 20
  }, _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 166.24,
    y: 235.172,
    width: 72.3145,
    height: 19.5332,
    rx: 9.76662,
    fill: "#FFD200"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_661)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 166.24,
    y: 235.172,
    width: 72.3145,
    height: 13.7148,
    rx: 6.85741,
    fill: "#FFE35F"
  }))), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 198.657,
    y: 254.705,
    width: 7.89641,
    height: 52.7813,
    fill: "#6A737D"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 173.721,
    y: 305.824,
    width: 57.7685,
    height: 4.57161,
    fill: "#6A737D"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 173.721,
    y: 315.383,
    width: 9.55882,
    height: 2.9092,
    transform: "rotate(-90 173.721 315.383)",
    fill: "#6A737D"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 201.151,
    y: 315.383,
    width: 9.55882,
    height: 2.9092,
    transform: "rotate(-90 201.151 315.383)",
    fill: "#6A737D"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 228.58,
    y: 315.383,
    width: 9.55882,
    height: 2.9092,
    transform: "rotate(-90 228.58 315.383)",
    fill: "#6A737D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M305.466 197.56L296.531 192.573V197.56H305.466Z",
    fill: "#FFDAB8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 333.113,
    cy: 24.4369,
    r: 15.4338,
    stroke: "#6638EB",
    strokeWidth: 2.5723
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.881,
    cy: 83.5999,
    r: 9.43178,
    stroke: "#FFD200",
    strokeWidth: 2.5723
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.0122,
    cy: 187.778,
    r: 5.57333,
    stroke: "#FFD200",
    strokeWidth: 2.5723
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.321,
    cy: 183.062,
    r: 3.85846,
    stroke: "#6638EB",
    strokeWidth: 1.71487
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 189.134,
    y: 1.81286,
    width: 15.1915,
    height: 15.1915,
    rx: 3.85846,
    transform: "rotate(40.3324 189.134 1.81286)",
    stroke: "#E6E9ED",
    strokeWidth: 2.5723
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M456.511 215.302L468.844 206.989L469.876 221.826L456.511 215.302Z",
    stroke: "#FFD200",
    strokeWidth: 2.5723
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerDown);
export default __webpack_public_path__ + "static/media/server_down.eb92b53c684019b69cd0b71b852430f6.svg";
export { ForwardRef as ReactComponent };